import styled, { css } from 'styled-components';
import { $ as $3ef42575df84b30b$export$9d1611c77c2fe928 } from '../../../3rdPartyModules/_react-aria/utils/dist/mergeProps-DMtmc2Zw.js';
import { b as basicStyles, m as mobileBasicStyles, d as disabledStyles, n as normalStyles$1 } from '../../../Button/ToggleArea/ToggleArea-DiNZFiFG.js';
import { i as isMobile } from '../../../theme/style-mixins/isMobile/isMobile-CGsYoba7.js';

const activeStyles = /*#__PURE__*/css(["border-color:", ";background-color:", ";border-color:unset;"], ({
  theme
}) => theme.button.toggleArea.borderColorActive, ({
  theme
}) => theme.button.toggleArea.bgActive);
const normalStyles = /*#__PURE__*/css(["", " border-color:unset;"], normalStyles$1);
const Label = /*#__PURE__*/styled.label.withConfig({
  componentId: "sc-storm-ui-30063520__sc-o0l76a-0"
})(["", " padding-left:0;padding-bottom:0;padding-right:0;padding-top:0;height:100%;width:100%;display:flex;flex:1;padding:0;border-radius:0;border:none;box-shadow:none;", " ", " outline:none;", ""], basicStyles, isMobile(css(["", " padding:0;"], mobileBasicStyles)), ({
  $active
}) => $active ? activeStyles : normalStyles, ({
  disabled
}) => disabled && css(["", ""], disabledStyles));
const Input = /*#__PURE__*/styled.input.attrs(({
  focusProps,
  onBlur,
  onFocus
}) => $3ef42575df84b30b$export$9d1611c77c2fe928({
  onBlur,
  onFocus
}, focusProps)).withConfig({
  componentId: "sc-storm-ui-30063520__sc-o0l76a-1"
})(["appearance:none;border:none;margin:0;padding:0;display:inline;outline:0;opacity:0;width:0;height:0;"]);

export { Input as I, Label as L };
//# sourceMappingURL=TileToggleArea.styles-Ne5i9qz2.js.map
